module.exports = __webpack_public_path__ + "static/media/undraw-awards-fieb.9d54dbe7.svg";